module.exports = __webpack_public_path__ + "static/img/bulk-uploaded@2x.59860da5.png";